'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _memoize = require('react-utils/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UIButton = require('../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIconCircle = require('../icon/UIIconCircle');

var _UIIconCircle2 = _interopRequireDefault(_UIIconCircle);

var _underscore = require('../utils/underscore');

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilePreviewLabel = _styledComponents2.default.label.withConfig({
  displayName: 'UIFileInput__FilePreviewLabel'
})(['margin-left:12px;']);

var getSuccessIcon = (0, _memoize2.default)(function () {
  return _react2.default.createElement(_UIIconCircle2.default, {
    backgroundColor: _colors.OZ_MEDIUM,
    color: _colors.OLAF,
    name: 'success',
    padding: 0.25,
    size: 9,
    verticalAlign: 'text-top'
  });
});

var UIFileInput = function (_PureComponent) {
  _inherits(UIFileInput, _PureComponent);

  function UIFileInput(props) {
    _classCallCheck(this, UIFileInput);

    var _this = _possibleConstructorReturn(this, (UIFileInput.__proto__ || Object.getPrototypeOf(UIFileInput)).call(this, props));

    _this.handleClick = function (evt) {
      var onClick = _this.props.onClick;

      _this._inputEl.click();
      if (onClick) onClick(evt);
    };

    _this.handleFileSelect = function (evt) {
      var onChange = _this.props.onChange;

      onChange((0, _SyntheticEvent2.default)(evt.target.files[0], evt));
    };

    _this._id = (0, _underscore.uniqueId)('file-input-');
    return _this;
  }

  _createClass(UIFileInput, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          accept = _props.accept,
          buttonClassName = _props.buttonClassName,
          changeLabel = _props.changeLabel,
          className = _props.className,
          id = _props.id,
          __onChange = _props.onChange,
          __onClick = _props.onClick,
          selectLabel = _props.selectLabel,
          showFilePreview = _props.showFilePreview,
          use = _props.use,
          value = _props.value,
          rest = _objectWithoutProperties(_props, ['accept', 'buttonClassName', 'changeLabel', 'className', 'id', 'onChange', 'onClick', 'selectLabel', 'showFilePreview', 'use', 'value']);

      var computedId = id || this._id;

      return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('private-file-button', className) },
        _react2.default.createElement(
          _UIButton2.default,
          {
            className: buttonClassName,
            onClick: this.handleClick,
            use: use
          },
          (0, _lazyEval2.default)(value ? changeLabel : selectLabel)
        ),
        showFilePreview && value && _react2.default.createElement(
          FilePreviewLabel,
          { htmlFor: computedId },
          getSuccessIcon(),
          ' ',
          value.name
        ),
        _react2.default.createElement('input', _extends({}, rest, {
          accept: accept.join(','),
          className: 'hidden',
          id: computedId,
          onChange: this.handleFileSelect,
          ref: function ref(_ref) {
            return _this2._inputEl = _ref;
          },
          type: 'file'
        }))
      );
    }
  }]);

  return UIFileInput;
}(_react.PureComponent);

UIFileInput.propTypes = {
  accept: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  buttonClassName: _propTypes2.default.string,
  changeLabel: (0, _createLazyPropType2.default)(_propTypes2.default.node).isRequired,
  onChange: _propTypes2.default.func,
  selectLabel: (0, _createLazyPropType2.default)(_propTypes2.default.node).isRequired,
  showFilePreview: _propTypes2.default.bool.isRequired,
  use: _UIButton2.default.propTypes.use,
  value: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(File), _propTypes2.default.shape({
    name: _propTypes2.default.string
  })])
};

UIFileInput.defaultProps = {
  accept: [],
  changeLabel: function changeLabel() {
    return _I18n2.default.text('salesUI.UIFileInput.defaultChangeLabel');
  },
  selectLabel: function selectLabel() {
    return _I18n2.default.text('salesUI.UIFileInput.defaultSelectLabel');
  },
  showFilePreview: true,
  use: 'secondary'
};

UIFileInput.displayName = 'UIFileInput';

exports.default = (0, _Controllable2.default)(UIFileInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/input/UIFileInput.js
// module id = 559
// module chunks = 177